<div class="wrapper">
  <div class="card">
    <div class="img-wrap">
      <img src="../../assets/images/reading.png" alt="logo" class="icon" />
    </div>
    <div class="det-wrap">
      <h3>{{ displayedMedium }}</h3>
      <p>Medium</p>
    </div>
  </div>
  <div class="card">
    <div class="img-wrap">
      <img src="../../assets/images/world.png" alt="logo" class="icon" />
    </div>
    <div class="det-wrap">
      <h3>{{ school?.affiliation?.board }}</h3>
      <p>Board</p>
    </div>
  </div>
  <div class="card">
    <div class="img-wrap">
      <img src="../../assets/images/books.png" alt="logo" class="icon" />
    </div>
    <div class="det-wrap">
      <h3>{{ displayedClasses }}</h3>
      <p>Classes</p>
    </div>
  </div>
  <div class="card">
    <div class="img-wrap">
      <img src="../../assets/images/areas.png" alt="logo" class="icon" />
    </div>
    <div class="det-wrap">
      <h3>{{ area }}</h3>
      <p>Campus Area</p>
    </div>
  </div>
</div>
